import api from "../../services/api";

export const bannerAnalyticsService = {

    async getDashboard() {

        const { data } = await api.get(
            "/analytics/admin/banner/dashboard/"
        );

        return data;

    },

    async getPerformance() {

        const { data } = await api.get(
            "/analytics/admin/banner/performance/"
        );

        return data;

    },

    async getTimeline() {

        const { data } = await api.get(
            "/analytics/admin/banner/timeline/"
        );

        return data;

    },

};